module.exports = __webpack_public_path__ + "img/sign_rule.96cf543f.jpg";